import { EnvModel } from "../models/env.model";

export default class UrlService {
    constructor(public env: EnvModel) {

    }

    public GetActiveQueryString() {
        const urlParams = new URLSearchParams(window.location.search);

        const activeQueryStrings: any = {};

        if (urlParams.has('embed')) {
            activeQueryStrings.embed = urlParams.get('embed');
        }

        if (urlParams.has('widget')) {
            activeQueryStrings.widget = urlParams.get('widget');
        }

        if (urlParams.has('qs')) {
            activeQueryStrings.qs = urlParams.get('qs');
        }

        if (urlParams.has('cid')) {
            activeQueryStrings.cid = urlParams.get('cid');
        }

        if (urlParams.has('type')) {
            activeQueryStrings.type = urlParams.get('type');
        }

        if (urlParams.has('source')) {
            activeQueryStrings.source = urlParams.get('source');
        }

        if (urlParams.has('tic')) {
            activeQueryStrings.tic = urlParams.get('tic');
        }

        if (urlParams.has('gaClientId')) {
            activeQueryStrings.gaClientId = urlParams.get('gaClientId');
        }

        if (urlParams.has('isEventListingWidget')) {
            activeQueryStrings.isEventListingWidget = urlParams.get('isEventListingWidget');
        }

        if (urlParams.has('aid') && urlParams.has('isEventListingWidget')) {
            activeQueryStrings.aid = urlParams.get('aid');
        }

        return activeQueryStrings;
    }

    public GetConfirmationPageUrl(bookingUrlId: string, widgetType: string, widgetEventId: number, isEventListingWidget: boolean, accountId: number, isWhiteLabel: boolean) {
        const activeQueryStrings = this.GetActiveQueryString();
        const confirmationPageQs = new URLSearchParams();

        confirmationPageQs.append('bookingUrlId', bookingUrlId);

        if (activeQueryStrings.embed || isWhiteLabel) {
            confirmationPageQs.append('embed', (activeQueryStrings.embed ? activeQueryStrings.embed : isWhiteLabel));
        }

        if (activeQueryStrings.widget || widgetType) {
            confirmationPageQs.append('widget', activeQueryStrings.widget ? activeQueryStrings.widget : 'true');
            if (widgetType && widgetEventId > 0) {
                confirmationPageQs.append('eid', widgetEventId.toString());
                confirmationPageQs.append('type', widgetType);
            }
            if (activeQueryStrings.gaClientId) {
                confirmationPageQs.append('gaClientId', activeQueryStrings.gaClientId);
            }
        }

        if (isEventListingWidget && accountId > 0) {
            confirmationPageQs.append('isEventListingWidget', 'true');
            confirmationPageQs.append('aid', accountId.toString());
        }

        return `${this.env.checkoutSitePath}/event/checkout/confirmation?${confirmationPageQs.toString()}`;
    }

    public GetCheckoutErrorUrl(isWhiteLabel: boolean, isWidget: boolean) {
        var errorQs = new URLSearchParams();
        if (isWhiteLabel) {
            errorQs.append('embed', 'true');
        }

        if (isWidget) {
            errorQs.append('widget', 'true');
        }

        return `${this.env.checkoutSitePath}/event/checkout/error?${errorQs.toString()}`;
    }

    public GetSessionPageUrl(eventId: number) {
        return `${this.env.eventSitePath}/${eventId}/sessions`;
    }

    public GetDataEntryPageUrl(eventId: number, sessionTimeId: number, sectionId: number) {
        let activeQs = this.GetValidQueryStringFromParams().toString();
        if (activeQs.length > 0) {
            activeQs = '?' + activeQs;
        }
        return `${this.env.eventSitePath}/${eventId}/sessions/${sessionTimeId}/sections/${sectionId}/dataentry${activeQs}`;
    }

    public GetNoCartItemsRedirectUrl(eventId?: number, redirectToGc?: boolean, isEventListing?: boolean, widgetType?: string, accountId?: number) {
      if (redirectToGc) {
        return this.getGcRedirect(widgetType, accountId, isEventListing);
      }

      let redirectUrl = `${this.env.bookingSitePath}/book/search`;

      const urlParams = new URLSearchParams(window.location.search);

      eventId = eventId ?? +urlParams.get('eid');

      if (eventId && !isNaN(eventId)) {
        if (widgetType) {
          var qs = `?embed=true&widget=true&type=${widgetType}`;
          redirectUrl = `${this.env.eventSitePath}/landing/${eventId}${qs}`;
        } else if (isEventListing && accountId > 0) {
          redirectUrl = `${this.env.eventSitePath}/landing/${eventId}?embed=true&wp=true&widget=true&isEventListingWidget=True&aid=${accountId}`;
        }
        else {
          redirectUrl = `${this.env.eventSitePath}/landing/${eventId}`;
        }

        if (urlParams.has('source')) {
          redirectUrl += `&source=${urlParams.get('source')}`;
        }
      }

      return redirectUrl;
  }

  private getGcRedirect(widgetType?: string, accountId?: number, isEventListing?: boolean) {
    let redirectUrl: string;

    if (widgetType) {
      redirectUrl = `${this.env.eventSitePath}/giftcertificate/${accountId}?embed=true&widget=true&type=${widgetType}`;
    } else if (isEventListing && accountId > 0) {
      redirectUrl = `${this.env.eventSitePath}/giftcertificate/${accountId}?embed=true&wp=true&widget=true&isEventListingWidget=True`;
    } else {
      redirectUrl = `${this.env.eventSitePath}/giftcertificate/${accountId}`;
    }
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('source')) {
      redirectUrl += `&source=${urlParams.get('source')}`;
    }
    return redirectUrl;
  }

    public GetValidQueryStringFromParams() {
        const activeQueryStrings = this.GetActiveQueryString();
        const validQs = new URLSearchParams();
        if (activeQueryStrings.ueo) {
            validQs.append('ueo', activeQueryStrings.ueo);
        }
        if (activeQueryStrings.track) {
            validQs.append('track', activeQueryStrings.track);
        }
        if (activeQueryStrings.qs) {
            validQs.append('qs', activeQueryStrings.qs);
        }
        if (activeQueryStrings.embed || activeQueryStrings.embed === '') {
            validQs.append('embed', 'true');
        }
        if (activeQueryStrings.p) {
            validQs.append('p', activeQueryStrings.p);
        }
        if (activeQueryStrings.aid) {
            validQs.append('aid', activeQueryStrings.aid);
        }
        if (activeQueryStrings.cid) {
            validQs.append('cid', activeQueryStrings.cid);
        }
        if (activeQueryStrings.widget) {
            validQs.append('widget', activeQueryStrings.widget);
        }
        if (activeQueryStrings.type) {
            validQs.append('type', activeQueryStrings.type);
        }
        if (activeQueryStrings.isEventListingWidget) {
            validQs.append('isEventListingWidget', activeQueryStrings.isEventListingWidget);
        }
        return validQs;
    }
}